import { SET_LOADING_ERROR, SET_QUERY_PARAMS, UPDATE_APP_DETAILS_LIST, UPDATE_LOADING_STATUS } from "./actionTypes";

const initialState = {
    appDetailsList : null,
    loadingStatus: false,
    loadingError: null,
    queryParams: null,
  }


  const appDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_APP_DETAILS_LIST:
            return {
                ...state,
                appDetailsList: action.payload,
            };

        case UPDATE_LOADING_STATUS:
            return {
                ...state,
                loadingStatus: action.payload,
            };
        case SET_LOADING_ERROR:
             return {
              ...state,
              loadingError: action.payload,
             }
        case SET_QUERY_PARAMS:
            return {
                ...state,
                queryParams: action.payload,
            }
        default:
              return state;
    }
};



  export default appDetailsReducer;